import React from "react";
import ClientContainer from "../../components/Our Client/ClientContainer";
import PageHeader from "../../components/common/PageHeader";

const OurClient = () => {
  return (
    <div>
      <PageHeader pageName={"Our Clients"} />

      <ClientContainer />
    </div>
  );
};

export default OurClient;
